// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearMessageText = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.66659 12.6693H5.33325C2.66659 12.6693 1.33325 12.0026 1.33325 8.66927V5.33594C1.33325 2.66927 2.66659 1.33594 5.33325 1.33594H10.6666C13.3333 1.33594 14.6666 2.66927 14.6666 5.33594V8.66927C14.6666 11.3359 13.3333 12.6693 10.6666 12.6693H10.3333C10.1266 12.6693 9.92659 12.7693 9.79992 12.9359L8.79992 14.2693C8.35992 14.8559 7.63992 14.8559 7.19992 14.2693L6.19992 12.9359C6.09325 12.7893 5.84659 12.6693 5.66659 12.6693Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.66675 5.33594H11.3334',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.66675 8.66406H8.66675',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearMessageText };
